const mutations = {
    setVendorTypeList(state, data) {
        state.vendorTypeList = data;
    },
    setVendorType(state, data) {
        state.vendorType = data;
    },
    resetVendorType(state) {
        state.vendorType = {
            label: '',

        }
    }

}
export default mutations;